module.exports = __webpack_public_path__ + "static/media/WelcomingPurchase.e6720936.png";